import type { TrialPlan } from './types';

/** Day N of the 7-day trial from its end date; null when unknown or outside the week. */
export function trialDayFromEndDate(trialEndDate: string | Date | null | undefined, now = Date.now()): number | null {
  const end = trialEndDate ? new Date(trialEndDate).getTime() : NaN;
  if (!Number.isFinite(end)) return null;
  const daysLeft = Math.ceil((end - now) / 86_400_000);
  if (daysLeft < 1 || daysLeft > 7) return null;
  return 8 - daysLeft;
}

/** "Tomorrow: Ethics. Opens at midnight." for the session end; null on the last day or once frozen. */
export function tomorrowTeaser(plan: TrialPlan): string | null {
  if (plan.frozen || plan.ended) return null;
  const title =
    plan.tomorrow?.opensTitle ?? plan.days.find((d) => d.day === plan.currentDay + 1)?.title;
  if (!title) return null;
  const reviews = plan.tomorrow?.reviewsWaiting ?? 0;
  const waiting = reviews > 0 ? `, and ${reviews} review${reviews === 1 ? '' : 's'} waiting` : '';
  return `Tomorrow: ${title}. Opens at midnight${waiting}.`;
}
